export const rootTypes = {
  MODAL_ADD_VISIBLE: "MODAL_ADD_VISIBLE",
}